import { render, staticRenderFns } from "./RevisionsDialog.vue?vue&type=template&id=3fd83174&scoped=true"
import script from "./RevisionsDialog.vue?vue&type=script&lang=js"
export * from "./RevisionsDialog.vue?vue&type=script&lang=js"
import style0 from "./RevisionsDialog.vue?vue&type=style&index=0&id=3fd83174&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd83174",
  null
  
)

export default component.exports